// @flow
import React from 'react';

import { DownloadLinksList } from 'Components/frameworks/download-links-list/DownloadLinksList.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  downloadLabel: string,
  id?: string,
  resort: {
    factSheetUrl: string,
  },
  resortId: string,
  text?: string,
};

export function ProductInformationSummaryLine({
  downloadLabel,
  id,
  resort: { factSheetUrl },
  resortId,
  text,
}: Props) {
  if (!factSheetUrl) {
    return null;
  }

  const links = [
    {
      label: downloadLabel,
      target: '_blank',
      trackingData: {
        categoryGA: 'resort',
        actionGA: 'CTA_download_factsheet',
        labelGA: resortId,
      },
      url: factSheetUrl,
    },
  ];

  return (
    <SiteContainer id={id} className="Line Line-DownloadLinksList">
      <DownloadLinksList className="bg-white py-5 shadow-bottom" links={links} text={text} />
    </SiteContainer>
  );
}
